<template>
  <div>
    <div id="chattool" class="text-xs-center">
      <v-tabs
        v-model="chattooltype"
        color="grey lighten-3"
        :slider-color="$vuetify.theme.primary"
        show-arrows
      >
        <v-tab v-if="selectedBot.theme == 'ticket'" ripple :key="'ticket'" :href="'#ticket'">{{
          $t('Ticket')
        }}</v-tab>
        <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Info') }}</v-tab>
        <v-tab v-if="selectedBot.theme == 'nvbb'" ripple :key="'qouta'" :href="'#qouta'">{{
          $t('Quota')
        }}</v-tab>
        <v-tab
          v-if="selectedBot.theme == 'scgworkplace'"
          ripple
          :key="'workplacecustomer'"
          :href="'#workplacecustomer'"
          >{{ $t('Workplace') }}</v-tab
        >
        <v-tab
          v-if="selectedBot.theme == 'scgallrent' && allrentcustomer && allrentcustomer.length"
          ripple
          :key="'allrentcustomer'"
          :href="'#allrentcustomer'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="selectedBot.theme == 'scgallrent' && allrentsupplier && allrentsupplier.length"
          ripple
          :key="'allrentsupplier'"
          :href="'#allrentsupplier'"
          >{{ $t('Supplier') }}</v-tab
        >
        <!-- <v-tab ripple :key="'conversation'" :href="'#conversation'">{{$t('Conversation')}}</v-tab> -->

        <v-tab v-if="!selectedUser.group_id" ripple :key="'ordersummary'" :href="'#ordersummary'">{{
          $t('Order Summary')
        }}</v-tab>
        <v-tab v-if="!selectedUser.group_id" ripple :key="'currentcart'" :href="'#currentcart'">{{
          $t('Current Cart')
        }}</v-tab>
      </v-tabs>
    </div>

    <div id style="overflow-y:auto; height: calc(100vh - 112px)">
      <!-- v-resize="onResizeToolList"
      :style="{ height: toolListHeight + 'px' }" -->
      <div v-if="chattooltype == 'customer'">
        <livechat-customers
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-customers>
      </div>
      <div v-if="chattooltype == 'workplacecustomer'">
        <scgworkplace-customer
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></scgworkplace-customer>
      </div>
      <div v-if="chattooltype == 'allrentcustomer'">
        <ScgAllrentCustomer
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
        ></ScgAllrentCustomer>
      </div>
      <div v-if="chattooltype == 'qouta'">
        <NvbbQouta
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
        ></NvbbQouta>
      </div>
      <div v-if="chattooltype == 'allrentsupplier'">
        <ScgAllrentSupplier
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
        ></ScgAllrentSupplier>
      </div>
      <div v-else-if="chattooltype == 'conversation'">
        <div class="pa-1 form-control">
          <input type="text" class="form-control" :placeholder="$t('Search')" />
        </div>
      </div>
      <div v-else-if="chattooltype == 'ordersummary'">
        <livechat-order-summary
          :key="`customer_order_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-order-summary>
      </div>
      <div v-else-if="chattooltype == 'currentcart'">
        <livechat-currentcart
          :key="`customer_currentcart_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-currentcart>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LivechatOrderSummary from './livechat-order-summary'
import LivechatCurrentcart from './livechat-currentcart'
import ScgworkplaceCustomer from './scgworkplace-customer.vue'
import ScgAllrentCustomer from './scgallrent-customer.vue'
import ScgAllrentSupplier from './scgallrent-supplier.vue'
import NvbbQouta from './NvbbQouta.vue'
import LivechatCustomers from './livechat-customers'
import api from '@/api'

export default {
  props: ['selectedUser'],
  components: {
    LivechatCurrentcart,
    LivechatOrderSummary,
    ScgworkplaceCustomer,
    ScgAllrentCustomer,
    ScgAllrentSupplier,
    NvbbQouta,
    LivechatCustomers
  },
  data() {
    return {
      chattooltype: 'customer',
      toolListHeight: 0,
      allrentcustomer: [],
      allrentsupplier: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    var vm = this
    if (this.selectedBot.theme == 'scgallrent') {
      vm.getallrenttransactionlivechat()
    }
    if (vm.selectedBot.theme == 'scgworkplace') {
      vm.chattooltype = 'workplacecustomer'
    }
    if (vm.selectedBot.theme == 'ticket') {
      vm.chattooltype = 'ticket'
    }
    vm.onResizeToolList()
  },
  methods: {
    getallrenttransactionlivechat() {
      if (this.selectedUser && this.selectedUser.userid) {
        var data = {
          pageid: this.$store.state.livechat.pageid,
          userid: this.selectedUser.userid
        }
        api.getallrenttransactionlivechat(data, (err, response) => {
          if (response.responsecode == 200) {
            this.allrentcustomer = response.data
            this.allrentsupplier = response.data2
          }
        })
      }
    },
    onResizeToolList: function() {
      var vm = this
      vm.$nextTick(function() {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    }
  },
  watch: {
    selectedUser: function(newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        if (this.selectedBot.theme == 'scgallrent') {
          vm.getallrenttransactionlivechat()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chattool.vue